export default class Asset {
  constructor(
    p5,
    x,
    y,
    img,
    name,
    sizeX,
    sizeY,
    anglee,
    speed = 0.01,
    history
  ) {
    this.myHistory = history;
    this.INITIAL_SPEED = speed + 0.2;
    this.INITIAL_ANGLEE = anglee;
    this.name = name;
    this._p5 = p5;
    this.img = img;
    this.posX = x * this._p5.cos(this._p5.radians(anglee));
    this.posY = y * this._p5.sin(this._p5.radians(anglee));
    this.y = y;
    this.sizeX = sizeX;
    this.sizeY = sizeY;
    this.anglee = anglee;
    this.speed = speed + 0.2;
  }

  _getDistance() {
    return this._p5.dist(
      this._p5.mouseX,
      this._p5.mouseY,
      this.posX,
      this.posY
    );
  }

  show() {
    let fullName = this.name.split("/");
    this.posX = this.posX - this.speed;

    if (this.speed) {
      if (this.posX < -540) {
        this.posX = 1600;
        this.posY = this.y - 160;
      } else if (this.posX >= 1600) {
        this.posX = -540;
        this.posY = this.y - 160;
      } else if (this.posX < 400) {
        this.posY = this.posY - 0.1 * 0.7;
      } else if (this.posX > 400 && this.posX < 600) {
        this.posY = this.posY - 0.06 * 0.7;
      } else if (this.posX > 800 && this.posX < 900) {
        this.posY = this.posY + 0.06 * 0.7;
      } else {
        this.posY = this.posY + 0.1 * 0.7;
      }
    }

    this._p5.image(this.img, this.posX, this.posY, this.sizeX, this.sizeY);
    this._p5.text(
      fullName[fullName.length - 1],
      this.posX + this.sizeX / 2.5,
      this.posY - 5
    );
    this.anglee += this.speed;
    this._p5.fill(200);
    this._p5.textSize(14);
  }

  clicked() {
    if (this._getDistance() < this.sizeY && !window.modalOpen) {
      let assetline = "sun";
      this.name.split("/").forEach(e => (assetline += "," + e.toLowerCase()));

      this.myHistory.push(`/assets/?assetline=${assetline}`, {});
    }
  }

  hover(stop) {
    if (this.isHover() || stop) {
      this._p5.cursor(this._p5.HAND);
      this.speed = 0;
    } else {
      this._p5.cursor(null);
      this.speed = this.INITIAL_SPEED;
    }

    return this.isHover();
  }

  isHover() {
    return this._getDistance() < this.sizeX;
  }

  drag(speed) {
    this.speed = speed;
  }
}



// WEBPACK FOOTER //
// ./src/containers/PlanetsPage/asset.js